import gql from 'graphql-tag';

export default gql`
  mutation verifyPhoneNumber($userLoginId: UUID!, $code: String!, $phoneNumber: String  ) {
    verifyPhoneNumber(userLoginId: $userLoginId, code: $code, phoneNumber: $phoneNumber)
  }
`;
